import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getConfigurationById } from '../api/vpc';
import { getEmptySolution, getEmptySolutionCornerGuide } from '../components/ProductList/utils';
import { useKompis } from '../contexts';
import { getFormState } from '../store/app/selectors';
import { SINGLE_WALL } from '../utils';
/** Get a suitable empty solution based on the data in the form state */
export const useEmptySolution = () => {
    const form = useSelector(getFormState);
    const { dexfAppSettings } = useKompis();
    const [emptySolution, setEmptySolution] = useState();
    useEffect(() => {
        const fetchEmptySolution = async () => {
            const emptySolutionCode = form.wall === SINGLE_WALL ? getEmptySolution(form) : getEmptySolutionCornerGuide(form);
            const emptySolution = await getConfigurationById(emptySolutionCode, dexfAppSettings);
            if (!emptySolution) {
                setEmptySolution(undefined);
                return;
            }
            setEmptySolution({
                vpc: emptySolutionCode,
                vpcData: emptySolution,
                articles: {},
                signifiers: [],
                cluster_size: 0
            });
        };
        fetchEmptySolution();
        return () => {
            setEmptySolution(undefined);
        };
    }, [form, dexfAppSettings]);
    return emptySolution;
};
//# sourceMappingURL=useEmtpySolution.js.map